import api from '@/api';

function hasProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export default {
  namespaced: true,

  state: {
    data: [],
    currentItem: {},
  },

  getters: {
    //
  },

  mutations: {
    setData(state, data) {
      state.data = data;
    },

    setCurrentItem(state, data) {
      state.currentItem = Object.assign({}, data);
    },
  },

  actions: {
    list({ commit }, params) {
      commit('setData', []);

      const { questionId } = params;

      let endpoint = `/collaboration/question/${questionId}/ideas`;

      if (params.isFlat) {
        endpoint = `${endpoint}/flat`;
      }

      api()
        .get(endpoint)
        .then((response) => {
          commit('setData', response.data.data.idea);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'idea')) {
            commit('setData', error.response.data.data.idea);
          }
        });
    },

    read({ commit, state }, itemId) {
      commit('setCurrentItem', null);

      api()
        .get(`/collaboration/question${itemId}`)
        .then((response) => {
          commit('setCurrentItem', response.data.data.question[0]);
        })
        .catch((error) => {
          if (error.response && hasProp(error.response.data.data, 'question')) {
            const question = error.response.data.data.question[0];
            commit('setCurrentItem', question);
          }
        });
    },
  },
};
